const Form071EN = {
    stepName: {
        statement: "Important Notes",
        basicInfor: "Basic Information",
        promotion: "Promotion Appointment Details",
        certification: "Certification",
        noteInformation: "Note Information",
        application: "Annex for Staff Establishment and Strength Table",
        promotionSupplementary: "Supplementary Sheet for Staff Promotion",
        confirmation: "Confirmation",
    },
    errorMsg: {
        date: {
            afterThisDate: "Please select a date after {{name}} {{targetDate}}",
        },
        year: "Date of Next Increment should be the year of Effective Date or the year after",
        equal4: "Please input the four-digit school code",
        equal8: "Please input the eight-digit SRN",
    },
    label: {
        note: "Notes",
        statement: "Personal Information Collection Statement",
        termsCon1:
            'I have read the "Personal Information Collection Statement" and fully understand its content.',
        termsCon2:
            'I understand that an "iAM Smart+" account is required for processing the application.',
        schoolInfor: "Basic Information",
        basicInfoNote1:
            "Please complete one form for each promotion appointment.",
        basicInfoNote2:
            "Please read the Personal Information Collection Statement carefully before completing this form.",
        basicInfoNote3:
            "Please ensure the content of this form is made known to the staff and he/she has read the Personal Information Collection Statement.",
        basicInfoNote4:
            "EDB will perform pre-processing entitlement checking on each promotion. If the promotion of staff would exceed the approved entitlement of teaching/non-teaching staff of the school on the relevant promotion date, no Salaries Grant with respect to that promotion will be paid to the school until the promotion is confirmed in order.",
        staffInfor: "Details of Promotion Appointment",
        schName: "School Name",
        schCode: "School Code",
        schProgram: "School Session",
        contactPerson: "School's Contact Person",
        telNumber: "Telephone number",
        andTel: " and tel. no.",
        enquiry: "(for enquiry by EDB in processing this form)",
        management: "IMC/SMC",
        referenceNumber: "Ref. No.",
        referenceNo: "Reference No.",
        date: "Date",
        committee1: "The ",
        committee2:
            "has approved the following promotion appointment (Ref. No.",
        committee3: "and Date:",
        committee4: "  ) and the consequential change in salary particulars:",
        nameEnlish: "Name of Staff in English",
        nameChinese: "Name of Staff in Chinese",
        HKICNo: "HKIC No.",
        SRN: "SRN",
        schoolHead: "School head",
        effectiveDate: "Effective Date",
        effectiveDtNote:
            "All the necessary procedures for promoting a teacher/non-teaching staff should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances, there should be no retrospective effect for the date of promotion.",
        incrementalDate: "Incremental Date",
        nextIncrementalYear: "Year of Next Increment",
        nextIncrementalDate: "Date of Next Increment",
        maximumSalary: "Maximum Salary (MPS Pt.)",
        responsibilities: "The promotee's functional responsibilities are",
        responsibility: "Responsibility",
        fileRefNo: "File Ref. No.",
        andDate: "and Date",
        fileDate: "File Date",
        approvalLetter: "Approval Letter",
        SSDO: "SSDO",
        ssdo: "Respective Regional Education Office [Attn : ",
        ssdo1: "] Education Bureau",
        attachmentFor: "Attachment for {{school}}",
        attachment: "Attachment",
        annex: "Click here to download the Annex form",
        type: "Annex for School(For Ordinary Primary School/For Ordinary Secondary School/For Special School)",
        supervisorName: "Name of School Supervisor",
        note3: "The Staff Establishment and Strength Table at the <u>Annex</u> indicates that a vacancy is available for the above promotion.",
        note5: "For promotion to fill the vacancy of Assistant Master/Mistress (AM)/ Senior Assistant Master/Mistress (SAM), the teachers should have been acting for substantive appointment in the non-graduate grade before the 2019/20 school year. Starting from the 2019/20 school year, the promotion mechanism for the non-graduate grade will cease to operate. In other words, with the exception of the aforementioned situation, there should not be any new promotion and acting appointment (for substantive appointment) in the non-graduate grade.",
        note6: "I confirm that the particulars in paragraphs 1 to 5 of this form are correct. I undertake that the promotion will not result in having the number of staff holding the posts at the promotion ranks in excess of our approved entitlement. I also undertake that my School shall refund any over-payment of Salaries Grant to the Education Bureau.",
        promotion:
            "For promotion to fill the vacancy of school head, please provide details of prior approval sought from Education Bureau:",
        establishment: "Staff Establishment and Strength Table",
        title: "Original",
        title1: "- Funds Section, Education Bureau",
        title2: "Duplicate",
        title3: "- Respective Regional Education Office [Attn : ",
        title4: "] Education Bureau",
        title5: "Triplicate",
        title6: "- School's Record",
        fileDateWarningMsg:
            "Prior approval should be sought from Education Bureau.  For enquiries, please contact the respective School Development Officers.",
        certificationCheckboxText:
            "I have read, understood and agreed to the above terms and conditions",
        dialogText: "Please select the corresponding school attachment first",
        personalParticulars: "(i) Personal Particulars",
        promotionRank: "(ii) Promotion Rank",
        promotionRequirement:
            "(iii) Completed Training Requirements for Promotion",
        promotionRequirementMsg:
            "I confirm that I have completed the designated training programmes for promotion to the related promotion rank, including the training programmes in the Core Part and the required number of hours of training programmes in the Elective Part, within five years prior to the effective date of the promotion post.",
        titleText: "Title",
    },
    table: {
        salary: "Monthly Salary",
        maxPoint: "(MPS Pt.)",
        rank: "Rank",
        before: "Before Promotion",
        after: "Upon Promotion",
    },
    programValue: {
        am: "AM",
        pm: "PM",
        wholeDay: "Whole Day",
    },
    typeValue: {
        Primary: "Ordinary Primary School",
        Secondary: "Ordinary Secondary School",
        Special: "Special School",
    },
    SMCValue: {
        school: "School Management Committee",
        incorporated: "Incorporated Management Committee",
    },
    SSDOValue: {
        0: "North District",
        1: "Kwai Chung & Tsing Yi District",
        2: "Sai Kung District",
        3: "Hong Kong East District",
        4: "Tuen Mun District",
        5: "Kowloon City District",
        6: "Kwun Tong District",
        7: "Southern District",
        8: "Yau Tsim & Mong Kok District",
        9: "Tsuen Wan District",
        10: "Sha Tin District",
        11: "Sham Shui Po District",
        12: "Tai Po District",
        13: "Wan Chai District",
        14: "Islands District",
        15: "Central & Western District",
        16: "Yuen Long District",
        17: "Wong Tai Sin District",
    },
    dateValue: {
        1: "01/01",
        2: "01/02",
        3: "01/03",
        4: "01/04",
        5: "01/05",
        6: "01/06",
        7: "01/07",
        8: "01/08",
        9: "01/09",
        10: "01/10",
        11: "01/11",
        12: "01/12",
    },
    salaryValue: {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13",
        14: "14",
        15: "15",
        16: "16",
        17: "17",
        18: "18",
        19: "19",
        20: "20",
        21: "21",
        22: "22",
        23: "23",
        24: "24",
        25: "25",
        26: "26",
        27: "27",
        28: "28",
        29: "29",
        30: "30",
        31: "31",
        32: "32",
        33: "33",
        34: "34(33A)",
        35: "35(33B)",
        36: "36(33C)",
        37: "37",
        38: "38",
        39: "39",
        40: "40",
        41: "41",
        42: "42",
        43: "43",
        44: "44",
        45: "45(44A)",
        46: "46(44B)",
        47: "47",
        48: "48",
        49: "49",
    },
    noteList: {
        note1: "All the necessary procedures for promoting a teacher/non-teaching staff should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances, there should be no retrospective effect for the date of promotion.",
        note2: "EDB will perform pre-processing entitlement checking on each promotion. If the promotion of staff would exceed the approved entitlement of teaching/non-teaching staff of the school on the relevant promotion date, no Salaries Grant with respect to that promotion will be paid to the school until the promotion is confirmed in order.",
    },
    labelStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
    ],
    certificationList: {
        text1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        text2: "processing employment-related matters;",
        text3: "processing payment of Salaries Grant and other government funding;",
        text4: "calculation of provident fund contribution;",
        text5: "auditing;",
        text6: "conducting research and compiling statistics to facilitate planning of education services;",
        text7: "processing matters relating to the development of the education profession;",
        text8: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
        text9: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        text10: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        text11: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form. This is however subject to payment of a fee.",
        text12: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
    },
    note: {
        note1: "The Staff Establishment and Strength Table at the <u>Annex</u> indicates that a vacancy is available for the above promotion.",
        note2: "The promoted teacher has fulfilled the promotion requirements as prescribed in the relevant Codes of Aid and Education Bureau circulars, including academic qualifications, teacher training qualifications, years of service and training requirements, etc.",
        note3: "For promotion to fill the vacancy of school head, the relevant promotion has been approved by the Education Bureau (File Ref. No. and Date: <u>{{refNoDate}}</u>).",
        note4: "For promotion to fill the vacancy of Assistant Master/Mistress (AM)/ Senior Assistant Master/Mistress (SAM), the teachers should have been acting for substantive appointment in the non-graduate grade before the {{schYear}} school year. Starting from the {{schYear}} school year, the promotion mechanism for the non-graduate grade will cease to operate. In other words, with the exception of the aforementioned situation, there should not be any new promotion and acting appointment (for substantive appointment) in the non-graduate grade.",
        note5: "I confirm that the particulars in paragraphs 1 to 6 of this form and the supplementary sheet (applicable for promotion to Primary School Master/Mistress (PSM)/ Senior Graduate Master/Mistress (SGM)/ Senior Primary School Master/Mistress (SPSM)/ Principal Graduate Master/Mistress (PGM)) are correct and the promotion will not result in having the number of staff holding the posts at the promotion ranks in excess of our approved entitlement. I undertake that if the relevant promotion does not comply with the existing promotion requirements, my School shall refund any over-payment of Salaries Grant due to erroneous promotion to the Education Bureau.",
    },
    rankValue: {
        PSM: "Primary School Master/Mistress (PSM)",
        SGM: "Senior Graduate Master/Mistress (SGM)",
        SPSM: "Senior Primary School Master/Mistress (SPSM)",
        PGM: "Principal Graduate Master/Mistress (PGM)",
        others: "Others",
    },
    titleValue: {
        Mr: "Mr",
        Miss: "Miss",
        Ms: "Ms",
    },
};
export default Form071EN;
